import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { LocalizationService } from './localization.service';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [],
})
export class LocalizationModule {
  static forRoot(): ModuleWithProviders<LocalizationModule> {
    return {
      ngModule: LocalizationModule,
      providers: [LocalizationService],
    };
  }
}
